import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormControl,
  UntypedFormGroup } from '@angular/forms';
import {
  MessageBarStore,
  SOFTLINE_FEATURE_MESSAGE_BAR,
  Validators } from '@softline/ui-core';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_PASSWORD } from '../../password.shared';
import { PasswordStore } from '../../store/password.store';

import {
  ResetPassword,
  UserInfoService,
  UserValidationInfo } from '@softline/auth';
import passwordConfirmValidator = Validators.passwordConfirmValidator;
import passwordValidator = Validators.passwordValidator;

import { InputComponent } from '@softline/ui-core';
import { IsValidPipe } from '@softline/ui-core';
import { PasswordInputComponent } from '@softline/ui-core';
import { SeparatorComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
import { ValidationContainerComponent } from '@softline/ui-core';
import { ValidationMessagePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-password-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ReactiveFormsModule,
    InputComponent,
    IsValidPipe,
    PasswordInputComponent,
    SeparatorComponent,
    TranslatePipe,
    ValidationContainerComponent,
    ValidationMessagePipe] })
export class SettingsComponent implements OnInit {
  private store = inject(Store);
  private readonly userInfo = inject(UserInfoService);

  emailForm = new UntypedFormGroup({
    username: new UntypedFormControl(''),
    email: new UntypedFormControl('', {
      validators: [Validators.required(), Validators.email()],
      updateOn: 'change' }) });

  passwordForm = new UntypedFormGroup({
    username: new UntypedFormControl(''),
    token: new UntypedFormControl('', {
      validators: [Validators.required()],
      updateOn: 'change' }),
    password: new UntypedFormControl('', {
      validators: [passwordValidator({ minLength: 8, strengthLevel: 4 })],
      updateOn: 'change' }),
    passwordRepeat: new UntypedFormControl('', {
      validators: [Validators.required(), passwordConfirmValidator()],
      updateOn: 'change' }) });

  async ngOnInit(): Promise<void> {
    const username = this.userInfo.value()?.userName;
    this.emailForm.patchValue({ username });
    this.passwordForm.patchValue({ username });
  }

  async sendToken(userValidation: UserValidationInfo): Promise<void> {
    try {
      await this.store.dispatch(
        SOFTLINE_FEATURE_PASSWORD,
        PasswordStore.actions.requestToken,
        userValidation
      );
      const message = '#PASSWORD.MESSAGES.CONFIRMATION_SENT';
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.success,
        message
      );
    } catch (e) {
      const message = '#PASSWORD.MESSAGES.CONFIRMATION_FAILED';
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
        message
      );
    }
  }

  async changePassword(resetPassword: ResetPassword): Promise<void> {
    try {
      const result = await this.store.dispatch(
        SOFTLINE_FEATURE_PASSWORD,
        PasswordStore.actions.resetPassword,
        resetPassword
      );
      if (result === true) {
        const message = '#PASSWORD.MESSAGES.RESET_SUCCESS';
        await this.store.dispatch(
          SOFTLINE_FEATURE_MESSAGE_BAR,
          MessageBarStore.actions.success,
          message
        );
      } else {
        const message = '#PASSWORD.MESSAGES.RESET_FAILURE';
        await this.store.dispatch(
          SOFTLINE_FEATURE_MESSAGE_BAR,
          MessageBarStore.actions.error,
          message
        );
      }
    } catch (e) {
      const message = '#PASSWORD.MESSAGES.RESET_FAILURE';
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
        message
      );
    }
  }
}
